(function () {
  const ROOT_SELECTOR = '[data-bymanay-size-guide-root]';

  function getDialogComponent() {
    return document.querySelector(ROOT_SELECTOR)?.querySelector('dialog-component');
  }

  const DEFAULT_SUBTITLE =
    'Medidas en centímetros · contorno de pecho, cintura y cadera.';
  const PRODUCT_GUIDE_TABS = new Set([
    'sweater-porto-fino',
    'chaqueta-amelia',
    'abrigo-greta',
  ]);

  const SUBTITLE_BY_TAB = {
    'sweater-porto-fino': 'Guía específica SWEATER PORTO FINO · medidas de la prenda.',
    'chaqueta-amelia': 'CHAQUETA AMELIA · Medidas en centímetros',
    'abrigo-greta':
      'Medidas de la prenda en centímetros · pecho, hombro, manga y largo.',
    calzado: 'Medidas en centímetros · longitud del pie.',
  };

  function activateTab(root, tabId) {
    if (!root || !tabId) return;

    root.querySelectorAll('[data-bymanay-size-tab]').forEach((btn) => {
      const active = btn.getAttribute('data-bymanay-size-tab') === tabId;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    root.querySelectorAll('[data-bymanay-size-panel]').forEach((panel) => {
      const active = panel.getAttribute('data-bymanay-size-panel') === tabId;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });

    const tabs = root.querySelector('.bymanay-size-guide__tabs');
    if (tabs) tabs.hidden = PRODUCT_GUIDE_TABS.has(tabId);

    const subtitle = root.querySelector('.bymanay-size-guide__subtitle');
    if (subtitle) {
      subtitle.hidden = false;
      subtitle.textContent = SUBTITLE_BY_TAB[tabId] ?? DEFAULT_SUBTITLE;
    }
  }

  function bindTabs(root) {
    root.querySelectorAll('[data-bymanay-size-tab]').forEach((btn) => {
      btn.addEventListener('click', () => {
        activateTab(root, btn.getAttribute('data-bymanay-size-tab'));
      });
    });

    root.querySelector('dialog')?.addEventListener('close', () => {
      activateTab(root, 'chaquetas');
    });
  }

  function openSizeGuide(options) {
    const root = document.querySelector(ROOT_SELECTOR);
    const dialogComponent = getDialogComponent();
    if (!root || !dialogComponent) return;

    if (options?.tab) activateTab(root, options.tab);
    if (typeof dialogComponent.showDialog === 'function') {
      dialogComponent.showDialog();
    }
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-bymanay-open-size-guide]');
    if (!trigger) return;
    event.preventDefault();
    const tab = trigger.getAttribute('data-bymanay-size-guide-tab') || undefined;
    openSizeGuide({ tab });
  });

  document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector(ROOT_SELECTOR);
    if (root) bindTabs(root);
  });

  window.BymanaySizeGuide = {
    open: openSizeGuide,
    activateTab: (tab) => activateTab(document.querySelector(ROOT_SELECTOR), tab),
  };
})();
